import {ThunkDispatch} from "@reduxjs/toolkit";
import {connect, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import {roomDesignActions} from '../reducers/roomDesign'
import {RoomType, LifestyleType} from '../constants'
import {getKeyByValue} from '../libs'
import {selectCanChangePageSetting, selectBeforeImageData} from '../selectors'
import pho_living from '../../assets/images/pho_living.png'
import pho_dining from '../../assets/images/pho_dining.png'
import pho_bedroom from '../../assets/images/pho_bedroom.png'
import pho_oneroom from '../../assets/images/pho_oneroom.png'
import pho_studio from '../../assets/images/pho_studio.png'
import pho_standard from '../../assets/images/pho_standard.webp'
import pho_modern from '../../assets/images/pho_modern.webp'
import pho_nordic from '../../assets/images/pho_nordic.webp'
import pho_industrial from '../../assets/images/pho_industrial.webp'
import pho_luxury from '../../assets/images/pho_luxury.webp'
import pho_midcentury from '../../assets/images/pho_midcentury.jpg'
import {NoticeIcon} from './SVGIcons'

function mapStateToProps(state: any) {
  const canChangePageSetting = selectCanChangePageSetting(state)
  const selectedBeforeImageData = selectBeforeImageData(state)
  return { ...state.roomDesign, canChangePageSetting, selectedBeforeImageData }
}

const RoomDesignEditRoomTypeLifestyle = (props: any) => {
  let {
    canChangePageSetting,
    selectedBeforeImageData
  } = props
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate()
  if (!selectedBeforeImageData) return null
  const {roomType, lifestyle, hasTatami, file} = selectedBeforeImageData
  let roomTypeImage
  if (roomType == "living")
    roomTypeImage = pho_living
  if (roomType == "dining")
    roomTypeImage = pho_dining
  if (roomType == "bedroom")
    roomTypeImage = pho_bedroom
  if (roomType == "oneRoom")
    roomTypeImage = pho_oneroom
  if (roomType == "studio")
    roomTypeImage = pho_studio

  let lifestyleImage
  if (lifestyle == "standard")
    lifestyleImage = pho_standard
  if (lifestyle == "modern")
    lifestyleImage = pho_modern
  if (lifestyle == "scandinavian")
    lifestyleImage = pho_nordic
  if (lifestyle == "industrial")
    lifestyleImage = pho_industrial
  if (lifestyle == "luxury")
    lifestyleImage = pho_luxury
  if (lifestyle == "midcentury")
    lifestyleImage = pho_midcentury
  
  const openRoomTypePopup = () => {
    if(!canChangePageSetting) return

    dispatch(roomDesignActions.setIsRoomTypePopupShow(true))
  }
  const openLifestylePopup = () => {
    if(!canChangePageSetting) return

    dispatch(roomDesignActions.setIsLifestylePopupShow(true))
  }
  const setHasTatami = (value: any) => {
    if(!canChangePageSetting) return

    dispatch(roomDesignActions.setHasTatami(value))
  }
  const roomTypeTxt: any = roomType ? getKeyByValue(RoomType, roomType) : "未選択"

  // ファイル名を60文字で省略
  const truncateFileName = (fileName: string, maxLength: number = 60) => {
    if (fileName.length <= maxLength) return fileName;

    const lastDotIndex = fileName.lastIndexOf('.');
    const extension = lastDotIndex !== -1 ? fileName.slice(lastDotIndex) : '';
    const nameWithoutExt = lastDotIndex !== -1 ? fileName.slice(0, lastDotIndex) : fileName;

    const maxNameLength = maxLength - extension.length - 3; // 3は省略記号の長さ
    if (maxNameLength <= 0) return fileName.slice(0, maxLength - 3) + '...';

    return nameWithoutExt.slice(0, maxNameLength) + '...' + extension;
  }

  return (
    <>
      <div className="flex">
        <span className="mb-2 text-sm text-slate-600 w-full">※全ての画像にて、出力設定を行ってください。</span>
        <span className="mb-2 text-sm text-slate-600 text-right w-full" title={file.name}>ファイル名：{truncateFileName(file.name)}</span>
      </div>
      <div className="mb-2 flex flex-wrap gap-3">
        <div className="w-auto flex items-center space-x-2">
          <div className="flex-shrink-1">
            <h3 className="mb-1 text-sm items-center">
              <strong>部屋タイプ</strong>
            </h3>
            <button onClick={openRoomTypePopup} disabled={!canChangePageSetting}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block min-w-36 max-w-auto p-2.5"
              type="button">
              {roomTypeTxt}
            </button>
          </div>
          <div className="w-16 h-16 rounded overflow-hidden">
            <img src={roomTypeImage} className="w-full h-auto object-cover"/>
          </div>
        </div>

        <div className="w-auto flex items-center space-x-2">
          <div className="flex-shrink-1 relative">
            <h3 className="mb-1 text-sm items-center">
              <strong>生活スタイル</strong>
            </h3>
            <button onClick={openLifestylePopup} disabled={!canChangePageSetting || roomType === 'oneRoom'}
              className={roomType === 'oneRoom'
                ? "bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg block w-36 p-2.5 cursor-not-allowed"
                : "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-36 p-2.5"}
              type="button">
              {roomType === 'oneRoom' ? "選択不可" : (lifestyle ? getKeyByValue(LifestyleType, lifestyle) : "未選択")}
            </button>
          </div>
          <div className="w-16 h-16 rounded overflow-hidden">
            {roomType !== 'oneRoom' && lifestyleImage && (
              <img src={lifestyleImage} className="w-full h-auto object-cover"/>
            )}
          </div>
        </div>

        <div className="w-auto flex items-center space-x-2">
          <div className="relative">
            <h3 className="mb-1 text-sm items-center flex">
              <strong className="mr-2">畳の有無</strong><NoticeIcon />
            </h3>
            <div className={roomType === 'oneRoom' 
              ? "bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg block w-36 p-2.5 cursor-not-allowed"
              : "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-36 p-2.5"}>
              <label className="mr-2">
                あり：<input type="radio" 
                  checked={roomType === 'oneRoom' ? false : hasTatami} 
                  onChange={() => setHasTatami(true)}
                  disabled={!canChangePageSetting || roomType === 'oneRoom'}/>
              </label>
              <label className="">
                なし：<input type="radio" 
                  checked={roomType === 'oneRoom' ? true : !hasTatami} 
                  onChange={() => setHasTatami(false)}
                  disabled={!canChangePageSetting || roomType === 'oneRoom'}/>
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps)(RoomDesignEditRoomTypeLifestyle)